import styled from 'styled-components'

export const Actions = styled.div`
  display: flex;
  align-items: flex-start;
`

export const Action = styled.div`
${({ theme: { colors } }) => `
  background: ${colors('chrome')};
  border-radius: 0.5rem;
  color: ${colors('text')};
  display: flex;
  font-size: 1rem;
  align-items: center;
  align-content: flex-start;
  justify-content: flex-start;
  width: auto;
  margin: 0.5rem 1rem 0 0;
  padding: 0.5rem;
  svg:first-child{
    margin: 0 0.5rem 0 0;
  }
  svg:last-child{
    margin: 0 0 0 0.5rem;
  }
`}
`

export const PostTypeSelector = styled.div`
  display: flex;
  gap: 1rem;
  margin-bottom: 1rem;
`

export const PostTypeOption = styled.div`
${({ theme: { colors }, selected }) => `
  background: ${selected ? colors('link') : colors('chrome')};
  color: ${selected ? colors('background') : colors('text')};
  border-radius: 0.5rem;
  padding: 1rem;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  flex: 1;
  &:hover {
    background: ${selected ? colors('link') : colors('chrome', 0.8)};
  }
`}
`
